import { render, staticRenderFns } from "./QualificationGrade.vue?vue&type=template&id=f51a40d4"
import script from "./QualificationGrade.vue?vue&type=script&lang=js"
export * from "./QualificationGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports